module.exports = __webpack_public_path__ + "assets/goals-days-practice.8c9e133d.svg";